import {
  Button,
  ButtonAlignment,
  ButtonStyles,
  ButtonWidth,
  useBreakpoint,
  useNextgenRouter,
  useTranslation,
} from '@nextgen-web-framework/all';
import { useState } from 'react';
import ErrorModal from '../error-modal/ErrorModal';
import useLogOut from '../../utils/customHooks/useLogOut';
import styles from './InactiveAccountErrorModal.module.scss';
import { InactiveAccountErrorModalProps } from './types/propTypes';

const InactiveAccountErrorModal = ({ onCloseCallback, callLogOut = true }: InactiveAccountErrorModalProps) => {
  const { replace } = useNextgenRouter();
  const t = useTranslation();
  const { getSignOutUrl } = useLogOut();
  const configs = ConfigService.getConfigs();
  const allowSelfLedRegistration =
    configs.NEXT_PUBLIC_IDENTITY_ALLOW_SELF_LED_REGISTRATION === undefined
      ? true
      : configs.NEXT_PUBLIC_IDENTITY_ALLOW_SELF_LED_REGISTRATION === 'true';
  const noAccessErrorHeader = t('identity.InactiveAccountErrorModal.noAccessErrorHeader');
  const noAccessErrorSubHeader1 = t('identity.InactiveAccountErrorModal.noAccessErrorSubHeader1');
  const noAccessErrorSubHeader2 = t('identity.InactiveAccountErrorModal.noAccessErrorSubHeader2');

  const closeButton = t('identity.InactiveAccountErrorModal.closeButton');
  const signUpButton = t('identity.InactiveAccountErrorModal.signUpButton');
  const viewPortType = useBreakpoint();
  const containerWidth = ['xs', 'sm'].indexOf(viewPortType) !== -1 ? '21.4375rem' : '36rem';
  const buttonWidth = ['sm', 'md'].includes(viewPortType) ? ButtonWidth.FULL_WIDTH : ButtonWidth.FIT_CONTENT;
  const buttonAlignment = ['xs', 'sm'].includes(viewPortType) ? ButtonAlignment.VERTICAL : ButtonAlignment.HORIZONTAL;
  const [showModal, setShowModal] = useState(true);
  const onClose = () => {
    setShowModal(false);
    callLogOut && getSignOutUrl();
    onCloseCallback?.();
  };
  const getSignUpUrl = () => {
    const configs = ConfigService.getConfigs();
    const redirectUrl = configs.NEXT_PUBLIC_REGISTER_REDIRECT_URL ?? '/complete-your-profile';
    return `/signup?flowName=${configs.NEXT_PUBLIC_REGISTER_FLOW}&returnUri=${redirectUrl}`;
  };
  const subHeader = (
    <>
      <span className={styles['inactive-account-subheader1']}>{noAccessErrorSubHeader1}</span>
      <span className={styles['inactive-account-subheader2']}>{noAccessErrorSubHeader2}</span>
    </>
  );
  const getPrimaryButton = (
    <Button data-testid="close-button-testid" title={closeButton} buttonWidth={buttonWidth} onClick={onClose} />
  );
  const getSecondaryButton = (
    <Button
      data-testid="signup-button-testid"
      buttonStyle={ButtonStyles.OUTLINE}
      title={signUpButton}
      buttonWidth={buttonWidth}
      onClick={() => replace?.(getSignUpUrl())}
    />
  );
  return (
    <div data-testid="inactive-account-modal-testid">
      {showModal && (
        <ErrorModal
          header={noAccessErrorHeader}
          primaryButtonLabel={closeButton}
          primaryButton={getPrimaryButton}
          {...(allowSelfLedRegistration && {
            secondaryButtonLabel: signUpButton,
            secondaryButton: getSecondaryButton,
          })}
          onClose={onClose}
          buttonAlignment={buttonAlignment}
          containerWidth={containerWidth}
          subHeader={subHeader}
          closeIcon={false}
        />
      )}
    </div>
  );
};

export default InactiveAccountErrorModal;
